/*! plata-script v6 */
(function () {
  "use strict";

  var loader = document.querySelector('script[data-plata-theme="plata"]');
  if (!loader || window.__plataInit) { return; }
  window.__plataInit = true;

  function attr(name, fallback) {
    var v = loader.getAttribute(name);
    return (v && String(v).trim()) || fallback || "";
  }

  function trimSlash(s) {
    return String(s || "").replace(/\/+$/, "");
  }

  var apiUrl = trimSlash(attr("data-plata-url"));
  var checkoutUrl = trimSlash(attr("data-checkout-domain"));
  var scriptMode = attr("data-plata-script", "ua");
  var shop =
    (window.Shopify && window.Shopify.shop) ||
    attr("data-plata-shop") ||
    "";

  if (!apiUrl && !checkoutUrl) { return; }

  var TRACKING_COOKIE = "plata_tracking";
  var BOUND_ATTR = "data-plata-bound";
  var TRACKING_KEYS = [
    "utm_campaign","utm_medium","utm_source","utm_content","utm_term","utm_id",
    "fbclid","ttclid","epik","ScCid","gclid"
  ];

  var CHECKOUT_FORM_SEL = [
    'form[action^="/cart"]:not([action^="/cart/"])',
    'form[action="/checkout"]',
    'form[action="/a/checkout"]'
  ].join(",");

  var CHECKOUT_BTN_SEL = [
    '[name="checkout"],[name="Checkout"]',
    '[class*="checkout-btn"],[class*="btn-checkout"]',
    '[class*="checkout-button"],[class*="button-checkout"]',
    '[class*="carthook_checkout"]',
    '[id*="checkout-button"],[id*="checkout-btn"]',
    '[href*="/checkout"][class*="action_button"]',
    '[data-checkout-button]'
  ].join(",");

  var CHECKOUT_LINK_SEL = 'a[href^="/checkout"],a[href*="/checkout"]';
  var BUYNOW_FORM_SEL = 'form[action^="/cart/add"][data-skip-cart="true"]';
  var DYNAMIC_BTN_SEL = [
    '[data-shopify="payment-button"] button',
    '[data-shopify="payment-button"] .shopify-payment-button__button'
  ].join(",");

  var inFlight = false;
  var prefetchedCart = null;
  var prefetchPromise = null;
  var prefetchedAt = 0;

  // A cart read at page load is stale the moment the buyer adds anything, and
  // a stale token means "Cart is empty" from the API. Re-read past this age.
  var CART_TTL_MS = 15000;
  var CART_WRITE_RE = /\/cart\/(add|change|update|clear)(\.js)?($|\?)/;

  // Checkout link prepared before the buyer commits. The server keeps a
  // handoff for 5 min; expire ours earlier so a warm click is never stale.
  var WARM_TTL_MS = 240000;
  var warm = null;
  var warmPromise = null;
  var rotatedFor = "";

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  }
  function nativeCheckout() {
    window.location.href = shopRoot() + "checkout";
  }

  function preconnectCheckout() {
    if (!checkoutUrl || !document.head) { return; }
    var origin;
    try { origin = new URL(checkoutUrl).origin; } catch (_) { origin = checkoutUrl; }
    if (document.querySelector('link[data-plata-preconnect]')) { return; }
    var link = document.createElement("link");
    link.rel = "preconnect";
    link.href = origin;
    link.crossOrigin = "anonymous";
    link.setAttribute("data-plata-preconnect", "1");
    document.head.appendChild(link);
    var dns = document.createElement("link");
    dns.rel = "dns-prefetch";
    dns.href = origin;
    document.head.appendChild(dns);
  }

  function fetchCart() {
    prefetchPromise = fetch(shopRoot() + "cart.js", {
      headers: { Accept: "application/json" },
      credentials: "same-origin"
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        prefetchedCart = cart;
        prefetchedAt = Date.now();
        return cart;
      });
    return prefetchPromise;
  }

  /** The cart as it is now — re-read once the cached copy could have moved. */
  function currentCart() {
    if (prefetchedCart && Date.now() - prefetchedAt < CART_TTL_MS) {
      return Promise.resolve(prefetchedCart);
    }
    return prefetchPromise && !prefetchedCart ? prefetchPromise : fetchCart();
  }

  /**
   * Every theme adds to the cart through /cart/add.js and friends, so watching
   * those calls is what keeps the prepared link tied to the real cart.
   */
  function watchCartWrites() {
    function isCartWrite(url) {
      try { return CART_WRITE_RE.test(String(url || "")); } catch (_) { return false; }
    }
    try {
      var nativeFetch = window.fetch;
      if (typeof nativeFetch === "function") {
        window.fetch = function (input) {
          var url = "";
          try {
            url = typeof input === "string" ? input : (input && input.url) || "";
          } catch (_) {}
          var result = nativeFetch.apply(this, arguments);
          if (isCartWrite(url) && result && typeof result.then === "function") {
            result.then(
              function () { invalidateCartPrefetch(); },
              function () {}
            );
          }
          return result;
        };
      }
    } catch (_) {}
    try {
      var open = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (_method, url) {
        try { this.__plataCartWrite = isCartWrite(url); } catch (_) {}
        return open.apply(this, arguments);
      };
      var send = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function () {
        if (this.__plataCartWrite) {
          this.addEventListener("loadend", function () {
            invalidateCartPrefetch();
          });
        }
        return send.apply(this, arguments);
      };
    } catch (_) {}
  }

  function invalidateCartPrefetch() {
    prefetchedCart = null;
    prefetchPromise = null;
    prefetchedAt = 0;
    warm = null;
    warmPromise = null;
  }

  function isCartPage() {
    try {
      return /(^|\/)cart\/?$/.test(window.location.pathname);
    } catch (_) {
      return false;
    }
  }

  function getCookie(name) {
    var parts = ("; " + document.cookie).split("; " + name + "=");
    if (parts.length < 2) { return undefined; }
    return decodeURIComponent(parts.pop().split(";").shift() || "");
  }
  function setCookieDays(name, value, days) {
    var exp = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie =
      name + "=" + encodeURIComponent(value) + "; expires=" + exp + "; path=/;";
  }
  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  var _gaCache = "";
  function getGaLinker() {
    if (_gaCache) { return _gaCache; }
    try {
      var gl = new URLSearchParams(window.location.search).get("_gl");
      if (gl) { _gaCache = "_gl=" + gl; return _gaCache; }
    } catch (_) {}
    try {
      if (typeof gtag !== "undefined" && Array.isArray(window.dataLayer)) {
        var hit = window.dataLayer.find(function (r) {
          return Array.isArray(r) && r[0] === "config" && typeof r[1] === "string" && r[1].startsWith("G-");
        });
        if (hit) {
          setTimeout(function () {
            try {
              gtag("get", hit[1], "linker_param", function (v) {
                if (v && v.indexOf("_gl=") !== -1) { _gaCache = v; }
              });
            } catch (_) {}
          }, 0);
        }
      }
    } catch (_) {}
    return "";
  }

  function saveTrackingParams() {
    var qs = new URLSearchParams(window.location.search);
    var stored = {};
    try { stored = JSON.parse(getCookie(TRACKING_COOKIE) || "{}"); } catch (_) {}
    var clickKeys = { fbclid: 1, ttclid: 1, gclid: 1, epik: 1, ScCid: 1 };
    var hasClick = false;
    var hasAny = false;
    var saved = {};
    Object.keys(stored).forEach(function (k) { saved[k] = stored[k]; });
    TRACKING_KEYS.forEach(function (k) {
      var v = qs.get(k);
      if (v) {
        saved[k] = v;
        hasAny = true;
        if (clickKeys[k]) { hasClick = true; }
      }
    });
    if (!hasAny) { return; }
    if (!hasClick && stored.fbclid && !qs.get("fbclid")) {
      saved.fbclid = stored.fbclid;
    }
    setCookieDays(TRACKING_COOKIE, JSON.stringify(saved), 7);
  }

  function collectPrivacy() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) { return null; }
      var marketing = typeof cp.marketingAllowed === "function" ? cp.marketingAllowed() : null;
      var sale = typeof cp.saleOfDataAllowed === "function" ? cp.saleOfDataAllowed() : null;
      var collected = typeof cp.visitorConsentCollected === "function"
        ? cp.visitorConsentCollected()
        : null;
      if (marketing == null && sale == null && collected == null) { return null; }
      return {
        marketingAllowed: marketing,
        saleOfDataAllowed: sale,
        visitorConsentCollected: collected,
        source: "shopify_privacy"
      };
    } catch (_) {
      return null;
    }
  }

  function randomId() {
    return (window.crypto && crypto.randomUUID)
      ? crypto.randomUUID()
      : String(Date.now()) + "-" + Math.random().toString(16).slice(2);
  }

  function entryKey(cartToken) {
    return "plata_entry:" + String(cartToken || "");
  }

  function entryRequestId(cartToken) {
    var key = entryKey(cartToken);
    try {
      var existing = sessionStorage.getItem(key);
      if (existing) { return existing; }
      var id = randomId();
      sessionStorage.setItem(key, id);
      return id;
    } catch (_) {
      return randomId();
    }
  }

  /** Retire a spent entry id so this cart can open a fresh handoff. */
  function rotateEntryRequestId(cartToken) {
    try { sessionStorage.removeItem(entryKey(cartToken)); } catch (_) {}
  }

  function buildAttribution() {
    var qs = new URLSearchParams(window.location.search);
    var stored = {};
    try { stored = JSON.parse(getCookie(TRACKING_COOKIE) || "{}"); } catch (_) {}
    var get = function (k) { return qs.get(k) || stored[k] || ""; };
    var out = {};
    var fbp = getCookie("_fbp"); if (fbp) { out.fbp = fbp; }
    var fbc = getCookie("_fbc"); if (fbc) { out.fbc = fbc; }
    var fbclid = get("fbclid"); if (fbclid) { out.fbclid = fbclid; }
    ["utm_source","utm_medium","utm_campaign","utm_content","utm_term","utm_id"].forEach(function (k) {
      var v = get(k);
      if (v) { out[k] = v; }
    });
    var lang = (navigator.languages && navigator.languages[0] || navigator.language || "").slice(0, 2);
    if (lang) { out.utm_lang = lang; out.locale = lang; }
    try { out.landingUrl = window.location.href; } catch (_) {}
    if (document.referrer) { out.referrer = document.referrer; }
    return out;
  }

  function goLegacyStart(cartToken) {
    var dest = checkoutUrl
      ? checkoutUrl + "/c/start"
      : apiUrl + "/shopify/checkout";
    window.location.href =
      dest +
      "?shop=" + encodeURIComponent(shop) +
      "&cart=" + encodeURIComponent(cartToken);
  }

  function handoffBody(cartToken) {
    var body = {
      shop: shop,
      cartToken: cartToken,
      entryRequestId: entryRequestId(cartToken),
      storefrontUrl: window.location.href,
      attribution: buildAttribution()
    };
    // Shopify's consent API loads asynchronously — omit the field until it has,
    // rather than sending a null the API cannot accept.
    var privacy = collectPrivacy();
    if (privacy) { body.privacy = privacy; }
    return JSON.stringify(body);
  }

  function requestHandoff(cartToken) {
    return fetch(apiUrl + "/shopify/checkout/handoff", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "omit",
      body: handoffBody(cartToken)
    })
      .then(function (res) {
        return res.json().catch(function () { return null; });
      })
      .then(function (data) {
        if (data && data.ok && data.checkoutUrl) { return data.checkoutUrl; }
        // A spent entry id can never produce a link again — retire it so the
        // next attempt opens a new handoff instead of failing for this cart.
        if (data && /handoff/i.test(String(data.message || ""))) {
          rotateEntryRequestId(cartToken);
          rotatedFor = cartToken;
        }
        return null;
      });
  }

  /** Prepare the link ahead of the click so the click is a plain redirect. */
  function warmHandoff(cartToken) {
    if (!(apiUrl && cartToken)) { return Promise.resolve(null); }
    if (warm && warm.cartToken === cartToken && Date.now() - warm.at < WARM_TTL_MS) {
      return Promise.resolve(warm.url);
    }
    if (warmPromise && warmPromise.cartToken === cartToken) {
      return warmPromise.promise;
    }
    var entry = { cartToken: cartToken, promise: null };
    entry.promise = requestHandoff(cartToken)
      .catch(function () { return null; })
      .then(function (url) {
        if (url) { warm = { cartToken: cartToken, url: url, at: Date.now() }; }
        if (warmPromise === entry) { warmPromise = null; }
        return url;
      });
    warmPromise = entry;
    return entry.promise;
  }

  function warmFromIntent() {
    currentCart()
      .then(function (cart) {
        if (cart && cart.token && cart.items && cart.items.length) {
          warmHandoff(cart.token);
        }
      })
      .catch(function () {});
  }

  function postHandoff(cartToken) {
    if (!apiUrl) {
      goLegacyStart(cartToken);
      return;
    }
    if (warm && warm.cartToken === cartToken && Date.now() - warm.at < WARM_TTL_MS) {
      window.location.href = warm.url;
      return;
    }
    return warmHandoff(cartToken)
      .then(function (url) {
        if (url) {
          window.location.href = url;
          return;
        }
        if (rotatedFor !== cartToken) {
          goLegacyStart(cartToken);
          return;
        }
        // That failure retired the stale id; one retry opens a fresh handoff.
        rotatedFor = "";
        return warmHandoff(cartToken).then(function (retried) {
          if (retried) {
            window.location.href = retried;
            return;
          }
          goLegacyStart(cartToken);
        });
      })
      .catch(function () { goLegacyStart(cartToken); });
  }

  function redirectWithCart(cart) {
    if (cart && cart.token) {
      return postHandoff(cart.token);
    }

    if (!cart || !cart.items || !cart.items.length) {
      nativeCheckout();
      return;
    }

    if (!apiUrl) {
      nativeCheckout();
      return;
    }

    return postHandoff(cart.token);
  }

  function fetchCartAndRedirect() {
    return currentCart().then(redirectWithCart);
  }

  function processCheckout(e) {
    if (e) { e.preventDefault(); e.stopImmediatePropagation(); }
    if (inFlight) { return; }
    inFlight = true;
    fetchCartAndRedirect()
      .catch(function (err) {
        console.error("[plata]", err);
        nativeCheckout();
      })
      .finally(function () { inFlight = false; });
  }

  function submitBuyNow(el) {
    if (inFlight) { return; }
    var form =
      (el.closest && el.closest("form")) ||
      document.querySelector('form[action^="/cart/add"]');
    if (!form) { return; }
    if (!form.querySelector('[name="quantity"]')) {
      var qi = document.createElement("input");
      qi.type = "hidden";
      qi.name = "quantity";
      qi.value = "1";
      form.appendChild(qi);
    }
    inFlight = true;
    invalidateCartPrefetch();
    var root = shopRoot();
    fetch(root + "cart/clear.js", { method: "POST", credentials: "same-origin" })
      .then(function () {
        return fetch(root + "cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          body: new FormData(form)
        });
      })
      .then(function () { return fetchCartAndRedirect(); })
      .catch(function (err) {
        console.error("[plata]", err);
        nativeCheckout();
      })
      .finally(function () { inFlight = false; });
  }

  var INTENT_EVENTS = ["pointerenter", "pointerdown", "touchstart", "focus"];

  function wrapEl(el, events, handler, warmOnIntent) {
    if (el.getAttribute(BOUND_ATTR)) { return; }
    el.setAttribute(BOUND_ATTR, "1");
    // Hover / first touch is enough intent to prepare the checkout link.
    if (warmOnIntent) {
      INTENT_EVENTS.forEach(function (ev) {
        el.addEventListener(ev, warmFromIntent, { passive: true, capture: true });
      });
    }
    events.forEach(function (ev) {
      window.addEventListener(
        ev,
        function (e) {
          if (e.target === el || el.contains(e.target)) {
            e.stopImmediatePropagation();
            e.preventDefault();
            handler(e);
          }
        },
        true
      );
    });
  }

  function bindAll() {
    document.querySelectorAll(CHECKOUT_FORM_SEL).forEach(function (el) {
      wrapEl(el, ["submit"], processCheckout, true);
    });
    document.querySelectorAll(CHECKOUT_BTN_SEL).forEach(function (el) {
      wrapEl(el, ["click"], processCheckout, true);
    });
    document.querySelectorAll(CHECKOUT_LINK_SEL).forEach(function (el) {
      wrapEl(el, ["click"], processCheckout, true);
    });
    document.querySelectorAll(BUYNOW_FORM_SEL).forEach(function (el) {
      wrapEl(el, ["submit"], function () { submitBuyNow(el); });
    });
    document.querySelectorAll(DYNAMIC_BTN_SEL).forEach(function (el) {
      wrapEl(el, ["click"], function () { submitBuyNow(el); });
    });
  }

  if (scriptMode === "ua" && !(window.Shopify && window.Shopify.country === "UA")) {
    return;
  }

  saveTrackingParams();
  preconnectCheckout();
  watchCartWrites();
  fetchCart()
    .then(function (cart) {
      // On the cart page checkout is the next step — prepare it up front.
      if (isCartPage() && cart && cart.token && cart.items && cart.items.length) {
        warmHandoff(cart.token);
      }
    })
    .catch(function () {});
  try {
    if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
      window.Shopify.loadFeatures(
        [{ name: "consent-tracking-api", version: "0.1" }],
        function () {}
      );
    }
  } catch (_) {}

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindAll);
  } else {
    bindAll();
  }

  window.addEventListener("load", function () {
    bindAll();
    var debouncedBind = debounce(bindAll, 400);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) {
          debouncedBind();
          break;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  });

  document.addEventListener("shopify:section:load", bindAll);
  document.addEventListener("shopify:payment_button:loaded", bindAll);

  window.addEventListener("pageshow", function () { inFlight = false; bindAll(); });
  window.addEventListener("focus", function () { if (inFlight) { inFlight = false; } });
  window.addEventListener("popstate", function () { inFlight = false; });
  document.addEventListener("visibilitychange", function () {
    if (!document.hidden && inFlight) { inFlight = false; }
  });
})();
